module.exports = __webpack_public_path__ + "static/media/clock-primary.e6bc904a.svg";